// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vukn8P {\n  margin-top: 25px;\n}\n", "",{"version":3,"sources":["webpack://./src/shared/Header/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".component {\n  margin-top: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"component": "vukn8P"
};
export default ___CSS_LOADER_EXPORT___;
